import { FLIPT_FLAGS } from "@/constants/constants";
import { useAuthStore } from "@/store/authStore";

// A function, not a module-level constant: constants.ts reaches this module
// again through its own imports, so FLIPT_FLAGS may not exist yet at load time.
const getFlagKey = () => FLIPT_FLAGS["multi-language-support"];

let cachedI18nEnabled: boolean | null = null;

const useIsI18nEnabled = (): boolean =>
	Boolean(useAuthStore((s) => s.user?.flags?.[getFlagKey()]));

const isI18nEnabled = (): boolean => {
	if (cachedI18nEnabled !== null) return cachedI18nEnabled;
	return Boolean(useAuthStore.getState().user?.flags?.[getFlagKey()]);
};

const fetchIsI18nEnabled = async (): Promise<boolean> => {
	try {
		const { getFliptFlag } = await import("@/helpers/get-flipt-flag");
		const result = await getFliptFlag({ flagKey: getFlagKey() });
		cachedI18nEnabled = result.enabled;
		return result.enabled;
	} catch {
		cachedI18nEnabled = false;
		return false;
	}
};

export { fetchIsI18nEnabled, isI18nEnabled, useIsI18nEnabled };
